import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { ClassNames } from '@emotion/react';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { GiftItemRow } from '@models/gift';
import { useTranslation } from 'react-i18next';

interface Props {
    giftItem: GiftItemRow;
    qty: number;
}

function ItemInfo({ giftItem, qty }:Props) {
    const { name, imageUrl, salePrice } = giftItem;
    const { t } = useTranslation('gift');
    const priceUnit = usePriceUnit();
    return (
        <Wrapper>
            <ClassNames>
                {({ css }) => (
                    <Accordion title={t('giftOrder.giftProduct')}
                        initialOpen
                        titleClassName={css`
                            font-weight: bold;
                            line-height: 28px;
                        `}>
                        <Contents spacing={16}
                            align='flex-start' >
                            <ImageBox>
                                <Image src={imageUrl}
                                    width={72}
                                    height={72}
                                    alt=''/>
                            </ImageBox>
                            <Column>
                                <Text size='lg' fontWeight='bold' color={colors.gray6}>
                                    {name}
                                </Text>
                                <Row spacing={8}>
                                    <Text color={colors.gray8}>{t('giftOrder.quantity', { qty })}</Text>
                                    <Dot />
                                    <Text color={colors.gray8}>{(salePrice * qty).toLocaleString()}{priceUnit}</Text>
                                </Row>
                            </Column>
                        </Contents>
                    </Accordion>
                )}
            </ClassNames>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding-top: 30px;
    width: 100%;
`;

const Contents = styled(Row)`
    padding: 12px 20px 6px;
`;

const ImageBox = styled.div`
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
    border-radius: 12px;
    border: 1px solid var(--color-gray2);
`;

const Dot = styled.div`
    background-color: var(--color-gray4);
    border-radius: 3px;
    height: 5px;
    width: 5px;
`;

export default ItemInfo;
